import { Component, OnDestroy, OnInit } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Router } from '@angular/router';
import { User } from '@lmc-app/shared/interface/user.interface';
import { UserService } from '@lmc-app/core/services/user.service';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';

@Component({
	selector: 'app-underwritingdashboard',
	templateUrl: './underwritingdashboard.component.html',
	styleUrls: [
		'./underwritingdashboard.component.scss',
		'../rapid-files/rapid-files-zoho/rapid-files-zoho.component.scss',
	],
})
export class UnderwritingdashboardComponent implements OnInit, OnDestroy {
	constructor(
		private apiService: LegacyApiService,
		private userService: UserService,
		private _routerLink: Router,
		private store: Store<State>
	) {}
	totalSchedule: number;
	todayDate = new Date();
	loginName: string;

	callCancelled: boolean = false;
	countBudgetAssessment: number;
	totalBudgetAssessment: number;
	countFileReview: number;
	totalFileReview: number;
	countUW: number;
	totalUW: number;
	countNeedsCoApp: number;
	totalNeedsCoApp: number;
	countAOB: number;
	totalAOB: number;
	countRapidUW: number;
	totalRapidUW: number;
	countScheduledInterview: number;
	countCoAppObtained: number;
	totalCoAppObtained: number;
	countCAPendingVOE:number;
	totalCAPendingVOE:number;
	currentUser: User;
	protected _onDestroy = new Subject<void>();
	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					this.loginName = user.full_name;
					this.currentUser = user;
				}
			});
	}

	// // async receiveDataFromSchedule(data:boolean){
	// // 	// await this.fetchUnderwritingSchedule();
	// // 	this.callCancelled=data;
	// // 	console.log(data,"___Call Cancelled")
	// // }

	// // countReadyForLoanInterview:number;
	// // totalReadyForLoanInterview:number;
	// // zeroAttempt:number;
	// // oneAttempt:number;
	// // moreAttempt:number;
	// // receiveDataFromReadyForLoanInterview(data:any){
	// // 	this.countReadyForLoanInterview=parseInt(data?.count);
	// // 	this.totalReadyForLoanInterview=parseFloat(data?.amount);
	// // 	this.zeroAttempt=parseFloat(data?.zeroAttempt);
	// // 	this.oneAttempt=parseFloat(data?.oneAttempt);
	// // 	this.moreAttempt=parseFloat(data?.moreAttempt);
	// // 	console.log(data,"___Ready for Loan Interview")
	// // }

	receiveDataFromBudgetAssessment(data: any) {
		this.countBudgetAssessment = parseInt(data?.count);
		this.totalBudgetAssessment = parseFloat(data?.amount);
	}

	receiveDataFromFileReview(data: any) {
		this.countFileReview = parseInt(data?.count);
		this.totalFileReview = parseFloat(data?.amount);
	}

	receiveDataFromUW(data: any) {
		this.countUW = parseInt(data?.count);
		this.totalUW = parseFloat(data?.amount);
	}

	receiveDataFromNeedsCoAp(data: any) {
		this.countNeedsCoApp = parseInt(data?.count);
		this.totalNeedsCoApp = parseFloat(data?.amount);
	}

	receiveDataFromAOB(data: any) {
		this.countAOB = parseInt(data?.count);
		this.totalAOB = parseFloat(data?.amount);
	}

	receiveDataFromRapidUW(data: any) {
		this.countRapidUW = parseInt(data?.count);
		this.totalRapidUW = parseFloat(data?.amount);
	}

	receiveDataScheduledInterview(count: number) {
		this.countScheduledInterview = count;
	}

	receiveDataFromCoAppObtained(data: any) {
		this.countCoAppObtained = parseInt(data?.count);
		this.totalCoAppObtained = parseFloat(data?.amount);
	}

	receiveDataFromCAPendingVOE(data: any) {
		this.countCAPendingVOE = parseInt(data?.count);
		this.totalCAPendingVOE = parseFloat(data?.amount);
	}

	refresh() {
		window.location.reload();
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}
